import { Box, Tab, Tabs } from "@mui/material";
import LicensePackageContainer from "./licensePackage";

import { Super_Admin_Module } from "../../../constant/ApplicationVariables";
import { useState } from "react";
import LicenseAddOnContainer from "./licenseAddOn";
import { useApplicationContext } from "../../../context/ApplicationContext";


export default function LicenseContainer() {
    const { licenseList, setLicenseList, } = useApplicationContext();
    const [activeTab, setActiveTab] = useState(Super_Admin_Module.license);


    const handleChangeTabs = (event, newValue) => {
        setLicenseList([]);
        setActiveTab(newValue);
    }

    return (
        <Box className="flex-1 flex flex-col gap-4">

            {/* tabs container */}
            <Box className="flex gap-4 px-0 py-0">
                <Tabs
                    value={activeTab}
                    onChange={handleChangeTabs}
                    textColor="primary"
                    indicatorColor="secondary"
                    aria-label="license tabs example"
                    sx={{ px: 4, py: 0, border: `1px solid ${(theme) => theme.palette.primary}` }}

                >
                    {
                        [Super_Admin_Module.license, Super_Admin_Module.licenseAddon]?.map((module, index) => {
                            return <Tab key={index} label={module.charAt(0).toUpperCase() + module.slice(1).replace(/([A-Z])/g, ' $1').trim()} value={module} />
                        })
                    }
                </Tabs>
            </Box>


            {/* main container */}
            <Box className="flex-1 flex flex-col gap-4">
                {activeTab === Super_Admin_Module.license ? <LicensePackageContainer /> : <LicenseAddOnContainer />}
            </Box>


        </Box>
    )
}
